import { IPluginValidationList, IValidatedPlugin, IPluginEnroll, IShowEnrollValidOptions } from "./base/pluginModels";

/**
 * determines if this json message is of type plugin validation list
 * @param obj
 */
export const isPluginValidationListInterface = (obj: any): obj is IPluginValidationList => {
    if (typeof obj === "string") {
        const jsonObj = JSON.parse(obj);
        return typeof jsonObj.enrollType === "string" && jsonObj.validatedPlugins;
    }
    return typeof obj.enrollType === "string" && obj.validatedPlugins;
}

/**
 * determines if this json message is of type plugin validation single check
 * @param obj
 */
export const isValidatedPluginInterface = (obj: any): obj is IValidatedPlugin => {
    if (typeof obj === "string") {
        const jsonObj = JSON.parse(obj);
        return typeof jsonObj.validatePlugin === "string";
    }
    return typeof obj.validatePlugin === "string";
}

/**
 * determines if this json message is of type plugin enroll
 * @param obj 
 */
export const isPluginEnrollInterface = (obj: any): obj is IPluginEnroll => {
    if (typeof obj === "string") {
        const jsonObj = JSON.parse(obj);
        return typeof jsonObj.enrollType === "string" && typeof jsonObj.enrollData === "string" && jsonObj.validatedPlugins === undefined && jsonObj.validatePlugin === undefined;
    }
    return typeof obj.enrollType === "string" && typeof obj.enrollData === "string" && obj.validatedPlugins === undefined && obj.validatePlugin === undefined;
}

/**
 * returns the validatePlugins json result as an object array of valid plugins
 * @param obj 
 */
export const checkPluginValidatedList = (obj: any) => {
    if (isPluginValidationListInterface(obj)) {
        let jsonObj = {} as IPluginValidationList;
        if (typeof obj === "string") {
            jsonObj = JSON.parse(obj);
        }

        let validPlugins = {} as IShowEnrollValidOptions;

        jsonObj.validatedPlugins.forEach(plugin => {
            if (plugin === undefined || plugin === null) {
                return;
            }
            else if (plugin.enrollType === "mde")
                validPlugins.mde = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "camera")
                validPlugins.camera = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "print")
                validPlugins.print = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "omnikey")
                validPlugins.omnikey = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "morpho")
                validPlugins.morpho = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "suprema")
                validPlugins.suprema = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "nitgen")
                validPlugins.nitgen = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "lumidigm")
                validPlugins.lumidigm = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "extension")
                validPlugins.extension = plugin.validatePlugin === "valid" ? true : false;
            else if (plugin.enrollType === "controlid")
                validPlugins.controlid = plugin.validatePlugin === "valid" ? true : false;
        });
        return validPlugins;
    }
    return {};
};

/**
 * returns single validatePlugin as object for specific plugin
 * @param json 
 */
export const checkPluginIsValidate = (json) => {
    if (isValidatedPluginInterface(json)) {
        //console.log(json.enrollType)
        return json as IValidatedPlugin;
    }
    return {};
};

/**
 * simply returns the plugin command type from the json response
 * @param json 
 */
export const getEnrollResultCommandType = (json: string) => {
    const obj = JSON.parse(json);
    return obj.enrollType;
};